import { render, staticRenderFns } from "./EmbeddedAsset.vue?vue&type=template&id=51851356&scoped=true&"
import script from "./EmbeddedAsset.vue?vue&type=script&lang=js&"
export * from "./EmbeddedAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51851356",
  null
  
)

export default component.exports